import { useEffect, useState } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import DraggableTab from './DraggableTab';

export default function DraggableTabsList({
  selected,
  tabs,
  showHiddenTabs,
  onDragEnd,
  onTabClick,
  id,
}) {
  const [value, setValue] = useState(selected);

  useEffect(() => {
    setValue(selected);
  }, [selected]);

  /**
   * Handles click event for tab list
   */
  const handleChange = (e, newValue) => {
    const disabledPlatform = tabs.find(
      (t) => t.id.toString() === newValue,
    ).disabled;
    if (disabledPlatform) return;

    setValue(newValue);

    onTabClick(e, parseInt(newValue, 10));
  };

  const renderTabList = (droppableProvided) => (
    <TabList
      onChange={handleChange}
      orientation="vertical"
      aria-label="Draggable Tabs"
      variant="scrollable">
      {tabs.map((tab, index) => {
        const child = (
          <Tab
            label={tab.name}
            value={`${tab.id}`}
            // eslint-disable-next-line react/no-array-index-key -- needed by dnd
            key={index}
            disabled={tab.disabled && !showHiddenTabs}
            sx={tab.disabled ? { color: '#00000061' } : {}}
          />
        );

        return (
          (!tab.disabled || showHiddenTabs) && (
            <DraggableTab
              label={tab.name}
              isDragDisabled={!showHiddenTabs}
              value={`${tab.id}`}
              index={index}
              // eslint-disable-next-line react/no-array-index-key -- needed by dnd
              key={index}
              child={child}
            />
          )
        );
      })}
      {droppableProvided ? droppableProvided.placeholder : null}
    </TabList>
  );

  const renderTabListWrappedInDroppable = () => (
    <DragDropContext onDragEnd={onDragEnd}>
      <div>
        <Droppable
          droppableId="list"
          direction="vertical">
          {(droppableProvided) => (
            <div
              ref={droppableProvided.innerRef}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...droppableProvided.droppableProps}>
              {renderTabList(droppableProvided)}
            </div>
          )}
        </Droppable>
      </div>
    </DragDropContext>
  );

  return (
    <TabContext value={value.toString()}>
      <Box
        id={id}
        style={{ width: '100%' }}>
        <Stack direction="column">{renderTabListWrappedInDroppable()}</Stack>
      </Box>
    </TabContext>
  );
}
